var render = function render(_c,_vm){return _c('table',{staticClass:"table table-hover table-borderless table-numbered"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }